// framework
import { immerable, produce } from "immer";
// api
import * as Client from "../../../../api/Client";
import { CallResultError } from "../../../../api/callHelper";

export interface IRootViewModel {
    readonly licenceId: number | undefined;
    readonly summary: Client.GetPublicLicenceDetailsSummaryDto | undefined;
    readonly licenceHolder: Client.GetPublicLicenceDetailsLicenceHolderDto | undefined;
    readonly memorial: Client.GetPublicLicenceDetailsRegisterDto[];
    readonly isBusy: boolean;
    readonly error: CallResultError | undefined;

    licenceDetailsLoading(): IRootViewModel;
    licenceDetailsLoaded(response: Client.GetPublicLicenceDetailsResponseDto | undefined, error: CallResultError | undefined): IRootViewModel;
}

export class RootViewModel implements IRootViewModel {
    [immerable] = true;

    constructor() {
        this.licenceId = undefined;
        this.memorial = [];
        this.isBusy = false;
        this.error = undefined;
    }
    public readonly licenceId: number | undefined;
    public readonly summary: Client.GetPublicLicenceDetailsSummaryDto | undefined;
    public readonly licenceHolder: Client.GetPublicLicenceDetailsLicenceHolderDto | undefined;
    public readonly memorial: Client.GetPublicLicenceDetailsRegisterDto[];
    public readonly isBusy: boolean;
    public readonly error: CallResultError | undefined;

    public licenceDetailsLoading(): IRootViewModel {
        return produce(this, (draft) => {
            draft.isBusy = true;
        });
    }

    public licenceDetailsLoaded(response: Client.GetPublicLicenceDetailsResponseDto | undefined, error: CallResultError | undefined): IRootViewModel {
        return produce(this, (draft) => {
            if (response) {
                draft.licenceId = response.licenceId;
                draft.summary = response.summary;
                draft.licenceHolder = response.licenceHolder;
                draft.memorial = response.memorial;
            }
            draft.isBusy = false;
            draft.error = error;
        });
    }
}
